export const createListingDefaultValues = {
    dimensions: '',
    price: '',
    color: '',
    material: '',
    description: ''
};
